import React, { useState } from 'react';
import styles from '../../css/modal.module.scss';
import ActionButton from 'components/ActionButton';
import { isValidURL, showError } from 'utils';
import { populatePurchaseOrderItemsFromImage, updateInventoryItem } from 'services';
import ItemAddress from 'pages/inventory-items/detail/ItemAddress';
import _ from 'lodash';

const EditInventoryAddressModal = props => {
  const {
    onCancel,
    onSuccess,
    loading,
    inventoryId,
    setLoading,
  } = props;

  const [inventoryAddress, setInventoryAddress] = useState<Record<string, any>>({});
  const handleAddressChange = (key: string, addressObject: Record<string, any>) => {

    const address = {
      ...inventoryAddress,
      [key]: addressObject,
    };
    setInventoryAddress(address);
  };

  const updateInventoryAddressFn = async () => {
    setLoading(true);
    const dataToUpdate = { inventoryAddress };
    try {
      const sanitizedInventoryAddress = _.mapValues(
        _.mapKeys(
          _.pick(dataToUpdate.inventoryAddress, ['start', 'end']),
          (_, key) => `${key}InventoryAddress`,
        ),
        obj => _.pick(obj, ['furnitureNo', 'shelfNo', 'storageSection']),
      );
      const response = await updateInventoryItem({ id:inventoryId, ...sanitizedInventoryAddress });
      onSuccess(response);
    } catch (e) {
      showError(e);
    } finally{
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Update</div>
            <div className={styles['modal-title']}>Inventory Item Address</div>
          </div>
          <i className={'fa fa-times'} onClick={onCancel} />
        </div>
        <div className={styles['modal-body']}>
          <div className='row'>
            <div className='col'>
              <ItemAddress
                addressType={'Start'}
                inventoryAddress={inventoryAddress?.start}
                editInfo={true}
                loading={loading}
                setAddress={handleAddressChange}
              />
            </div>
            <div className='col'>
              <ItemAddress
                addressType={'End'}
                inventoryAddress={inventoryAddress?.end}
                editInfo={true}
                loading={loading}
                setAddress={handleAddressChange}
              />
            </div>
          </div>
        </div>

        <div className={styles['modal-footer']}>
          <div className={styles['cancel-button']}>
            <ActionButton
              text={'Cancel'}
              active={!loading}
              isLoading={false}
              onClick={onCancel}
              customClass='mr-2'
            />
          </div>
          <div className={styles['submit-button']}>
            <ActionButton
              text={'Update Address'}
              active={!loading}
              isLoading={loading}
              onClick={updateInventoryAddressFn}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditInventoryAddressModal;
